import axios from 'axios';

export function getAdvertiserAdDisplayLogs(token, params) {
    return axios.get(`${process.env.REACT_APP_API_URL}/advertiser/adDisplayLogs`, {
        headers: { Authorization: token },
        params: params || {}
    });
}
